import React from 'react';
import { useLocation } from 'react-router-dom';
import Seo, { SITE_URL } from './Seo';
import seoConfig from './seoConfig';

// Sitewide Organization schema — helps Google understand who Mokshiq is
// and can power a Knowledge Panel / sitelinks. Rendered on every page.
const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Mokshiq',
  alternateName: 'Rakle Service Private Limited',
  url: SITE_URL,
  logo: `${SITE_URL}/assets/images/logo.png`,
  description:
    'Mokshiq provides AEPS, DMT, recharge, bill payment, verification APIs, and white-label fintech software solutions across India.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '1st Floor, C 78, Sector-2',
    addressLocality: 'Noida',
    addressRegion: 'Uttar Pradesh',
    addressCountry: 'IN',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+91-7311104571',
    contactType: 'customer service',
    email: 'sales@mokshiq.in',
  },
  sameAs: [
    // Add real social profile URLs here (LinkedIn, Twitter/X, Facebook, Instagram)
  ],
};

// Routes that compute and render their OWN <Seo /> based on query-string
// content (see ServiceDetail.jsx, BlogDetails.jsx). RouteSeo must not also
// render a generic <Seo /> for these paths, or you get two <Helmet>
// instances fighting over the same <head> at once.
const SELF_MANAGED_ROUTES = ['/service_details', '/blog_detail'];

/**
 * Drop <RouteSeo /> once inside <App /> (above <Routes>).
 * It looks up the current path in seoConfig and renders the right
 * <title>/meta/canonical/OG tags automatically for every static route.
 */
function RouteSeo() {
  const { pathname } = useLocation();

  if (SELF_MANAGED_ROUTES.includes(pathname)) {
    return null;
  }

  const meta = seoConfig[pathname] || seoConfig['/'];

  return (
    <Seo
      title={meta.title}
      description={meta.description}
      keywords={meta.keywords}
      path={pathname}
      noindex={meta.noindex}
      jsonLd={pathname === '/' ? organizationJsonLd : undefined}
    />
  );
}

export default RouteSeo;